import React from "react";
import Top from "./components/Navbar";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./components/pages/Home";
import Planung from "./components/pages/Planung";
import Galabau from "./components/pages/Galabau";
import Pflege from "./components/pages/Pflege";
import Kontakt from "./components/pages/Kontakt";
import Datenschutz from "./components/pages/Datenschutz";
import AGB from "./components/pages/AGB";
import Impressum from "./components/pages/Impressum";
import Footer from "./Footer";



function App() {
  return (

      <Router>
          <Top />
      

        <body>
          <Routes>
            <Route path="/" element={<Home />}></Route>
            <Route path="/beratung&planung" element={<Planung />}></Route>
            <Route path="/galabau" element={<Galabau />}></Route>
            <Route path="/pflege&erhalt" element={<Pflege />}></Route>
            <Route path="/Kontakt" element={<Kontakt />}></Route>
            <Route path="Datenschutz" element={<Datenschutz />}></Route>
            <Route path="AGB" element={<AGB />}></Route>
            <Route path="Impressum" element={<Impressum />}></Route>
            
          </Routes>
        </body>

        <Footer />
 
      </Router>

  );
}

export default App;
